<template>
  <div id="cardGrafWhatsapp">
    <q-card-section>
      <div class="row items-center no-wrap">
        <div class="col">
          <div class="text-grey-9" style="font-size: 16px;">
            <router-link to="/whatsapp" style="text-decoration: none; color: black">
              Uso do WhatsApp
            </router-link>
          </div>
          <div class="text-grey-7" style="font-size: 13px;">{{ resumo }}</div>
        </div>

        <div class="col-auto">
          <q-btn color="grey-7" round flat icon="more_vert">
            <q-menu cover auto-close>
              <q-list>
                <q-item clickable @click="removerCard">
                  <q-item-section>
                    <div class="text">
                      <q-icon name="delete" /> Remover
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>
      </div>
    </q-card-section>

    <q-card-section>
      <div v-if="!temEnvios" class="text-center text-grey q-pa-md" style="padding-top: 50px">
        Nenhuma mensagem enviada neste período.
      </div>

      <div v-else ref="chartContainer">
        <apexchart
          v-if="ready"
          type="bar"
          height="270"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </q-card-section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueApexCharts from "vue3-apexcharts";

function plural(quantidade, singular, pluralizado) {
  return `${quantidade.toLocaleString("pt-BR")} ${quantidade === 1 ? singular : pluralizado}`;
}

export default {
  name: "card-graf-whatsapp",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      ready: false,
    };
  },
  methods: {
    removerCard() {
      this.$store.dispatch("trocaVisibilidadeCard", { cardId: "21" });
    },

    waitForContainerWidth() {
      const el = this.$refs.chartContainer;
      if (!el) return;

      if (el.offsetWidth > 0) {
        this.ready = true;
        return;
      }

      if (typeof ResizeObserver !== "undefined") {
        this._resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.contentRect.width > 0) {
              this.ready = true;
              this._resizeObserver.disconnect();
              this._resizeObserver = null;
              break;
            }
          }
        });
        this._resizeObserver.observe(el);
      } else {
        this.ready = true;
      }
    },
  },
  computed: {
    ...mapGetters(["fetchUser"]),
    grafico() {
      const db = this.fetchUser && this.fetchUser.db;
      return (db && db.whatsappsCount) || { categories: [], series: [], totais: { sucesso: 0, falha: 0 } };
    },
    temEnvios() {
      return this.grafico.totais.sucesso + this.grafico.totais.falha > 0;
    },
    resumo() {
      const { sucesso, falha } = this.grafico.totais;
      return `${plural(sucesso, "enviada", "enviadas")} · ${plural(falha, "falha", "falhas")}`;
    },
    // Cópia sem os observers da store antes de congelar: o freeze é raso, e o
    // ApexCharts entra em recursão quando recebe dados reativos.
    series() {
      return Object.freeze(this.grafico.series.map(serie => ({ name: serie.name, data: [...serie.data] })));
    },
    chartOptions() {
      return Object.freeze({
        chart: {
          id: "apex-whatsapp-" + this.$.uid,
          type: "bar",
          stacked: true,
          toolbar: { show: false },
          animations: { enabled: false },
          redrawOnParentResize: false,
          redrawOnWindowResize: false,
        },
        plotOptions: { bar: { columnWidth: "70%", borderRadius: 2 } },
        colors: ["#388E3C", "#D32F2F"],
        dataLabels: { enabled: false },
        xaxis: {
          categories: [...this.grafico.categories],
          title: { text: "Dia do mês" },
          labels: { style: { fontSize: "11px" } },
        },
        yaxis: {
          labels: { formatter: value => Math.round(value).toLocaleString("pt-BR") },
        },
        tooltip: { shared: true, intersect: false },
        legend: { position: "top", horizontalAlign: "left" },
      });
    },
  },
  mounted() {
    this.$nextTick(() => this.waitForContainerWidth());
  },
  watch: {
    // Sem envios o container do gráfico nem existe; quando os dados chegam sem
    // remontar o cartão, a largura precisa ser medida de novo.
    temEnvios(valor) {
      if (valor) this.$nextTick(() => this.waitForContainerWidth());
    },
  },
  beforeUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  },
};
</script>
